module.exports = __webpack_public_path__ + "static/media/iflares-icons-420x420-02.c8fbf986.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/iflares-icons-420x420-02.svg
// module id = 2204
// module chunks = 1